export function BackIcon({
  width = 24,
  height = 24,
  className = '',
}: {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.218 7.71761C12.512 8.00936 12.5138 8.48423 12.2221 8.77826L9.02531 12L12.2221 15.2217C12.5138 15.5158 12.512 15.9906 12.218 16.2824C11.9239 16.5741 11.4491 16.5723 11.1573 16.2783L7.43636 12.5283C7.14621 12.2358 7.14621 11.7642 7.43636 11.4717L11.1573 7.72174C11.4491 7.42771 11.9239 7.42586 12.218 7.71761Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.73535 12C7.73535 11.5858 8.07114 11.25 8.48535 11.25H16.0308C16.445 11.25 16.7808 11.5858 16.7808 12C16.7808 12.4142 16.445 12.75 16.0308 12.75H8.48535C8.07114 12.75 7.73535 12.4142 7.73535 12Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 12C2.25 6.61704 6.61704 2.25 12 2.25C17.383 2.25 21.75 6.61704 21.75 12C21.75 17.383 17.383 21.75 12 21.75C6.61704 21.75 2.25 17.383 2.25 12ZM12 3.75C7.44546 3.75 3.75 7.44546 3.75 12C3.75 16.5545 7.44546 20.25 12 20.25C16.5545 20.25 20.25 16.5545 20.25 12C20.25 7.44546 16.5545 3.75 12 3.75Z"
        fill="white"
      />
    </svg>
  );
}

export default BackIcon;
